import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NAaF5cWWJCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXpfc3ZWQmJZVkJ+XEY=');

ReactDOM.render(<App />, document.getElementById('root'));
